import { useCallback } from "react";
import { useGetMeQuery } from "../store/slices/accessApi";
import { Permission } from "./permissions";

// Текущий пользователь и проверка прав. Данные загружает AuthGate до показа приложения,
// поэтому внутри него user уже есть.
export const useCurrentUser = () => {
  const { data: user } = useGetMeQuery();

  const can = useCallback(
    (permission: Permission) => Boolean(user?.permissions.includes(permission)),
    [user]
  );

  return { user, can };
};
